import _toConsumableArray from "/home/patrick/jamespatrickleduc.github.io/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/patrick/jamespatrickleduc.github.io/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/patrick/jamespatrickleduc.github.io/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { lineLength } from '../geometry';
import { polygonHachureLines } from './scan-line-hachure';
export var DotFiller = /*#__PURE__*/function () {
  function DotFiller(helper) {
    _classCallCheck(this, DotFiller);

    this.helper = helper;
  }

  _createClass(DotFiller, [{
    key: "fillPolygon",
    value: function fillPolygon(points, o) {
      o = Object.assign({}, o, {
        curveStepCount: 4,
        hachureAngle: 0,
        roughness: 1
      });
      var lines = polygonHachureLines(points, o);
      return this.dotsOnLines(lines, o);
    }
  }, {
    key: "dotsOnLines",
    value: function dotsOnLines(lines, o) {
      var ops = [];
      var gap = o.hachureGap;

      if (gap < 0) {
        gap = o.strokeWidth * 4;
      }

      gap = Math.max(gap, 0.1);
      var fweight = o.fillWeight;

      if (fweight < 0) {
        fweight = o.strokeWidth / 2;
      }

      var ro = gap / 4;

      var _iterator = _createForOfIteratorHelper(lines),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var line = _step.value;
          var length = lineLength(line);
          var dl = length / gap;
          var count = Math.ceil(dl) - 1;
          var offset = length - count * gap;
          var x = (line[0][0] + line[1][0]) / 2 - gap / 4;
          var minY = Math.min(line[0][1], line[1][1]);

          for (var i = 0; i < count; i++) {
            var y = minY + offset + i * gap;
            var cx = this.helper.randOffsetWithRange(x - ro, x + ro, o);
            var cy = this.helper.randOffsetWithRange(y - ro, y + ro, o);
            var el = this.helper.ellipse(cx, cy, fweight, fweight, o);
            ops.push.apply(ops, _toConsumableArray(el.ops));
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return {
        type: 'fillSketch',
        ops: ops
      };
    }
  }]);

  return DotFiller;
}();